<fr-table [config]="tableConfig" [data]="this.data" Id="services-table">
  <div class="table-sub-header" above-table-body-space>
  </div>

  <div class="custom-table-header-space" table-header-space>
    <button id="btn" mat-flat-button class="fr-primary" color="primary" (click)='addService.emit()'>
      Add Service
    </button>
  </div>
</fr-table>